import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import type { CustomElementOptions } from 'vue';

import { shouldRetryQuery } from '@/shared/api/retry';

type App = Parameters<NonNullable<CustomElementOptions['configureApp']>>[0];

/** Подключает общий QueryClient с контрактом повторов region API. */
export const initPlugins = (app: App): void => {
  // Подключаем общий кэш запросов и единый retry predicate для всех адаптеров.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 3,
        retry: shouldRetryQuery,
      },
    },
  });

  // Регистрируем QueryClient в изолированном приложении кастомного элемента.
  app.use(VueQueryPlugin, { queryClient });
};
